import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "month_translate",
})
export class MonthTranslate implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(src: string): string {
    this.translate
      .get([
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ])
      .subscribe((val) => {
        Object.keys(val).forEach((key) => {
          src = src.split(key).join(val[key]);
        });
      });

    return src;
  }
}
